var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            { attrs: { "drawer-button-disabled": _vm.drawerButtonDisabled } },
            [
              _c(
                "w-toolbar-text",
                {
                  staticClass: "app-title",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [_vm._v(" " + _vm._s(_vm.$ct(_vm.titleKey)) + " ")]
              ),
              _vm.product.ID != 0
                ? _c(
                    "w-toolbar-item",
                    {
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          return _vm.remove()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "trash" } })],
                    1
                  )
                : _vm._e(),
              _c(
                "w-toolbar-item",
                {
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.edit()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "pen" } })],
                1
              ),
              _c(
                "w-toolbar-item",
                {
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-wrap": "", "no-margin": "" } },
                    [
                      _c("w-tabs", {
                        attrs: { tabs: _vm.tabs },
                        model: {
                          value: _vm.tab,
                          callback: function ($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab",
                        },
                      }),
                      !_vm.$wf.isSmDown
                        ? [
                            _c("w-spacer"),
                            _c(
                              "w-button",
                              {
                                staticClass: "cancel mr",
                                attrs: { icon: "ban" },
                                on: {
                                  click: function ($event) {
                                    return _vm.cancel()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("common.cancel")) + " "
                                ),
                              ]
                            ),
                            _c(
                              "w-button",
                              {
                                attrs: {
                                  icon: "pen",
                                  disabled: !_vm.hasPermission,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.edit()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("common.edit")) + " "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            {
              attrs: {
                tag: "div",
                "tag-attributes": { noMargin: true, noPadding: true },
              },
            },
            [
              _vm.currentTabKey == "general"
                ? _c("app-tab-1", { key: 1, attrs: { product: _vm.product } })
                : _vm.currentTabKey == "buy"
                ? _c("app-tab-2", { key: 2, attrs: { product: _vm.product } })
                : _vm.currentTabKey == "stock"
                ? _c("app-tab-3", { key: 3, attrs: { product: _vm.product } })
                : _vm.currentTabKey == "extra-fields"
                ? _c("app-tab-4", { key: 4, attrs: { product: _vm.product } })
                : _c("app-extra-field-tab", {
                    key: "extra-field-" + _vm.tab,
                    attrs: {
                      value: _vm.product.ExtraFields,
                      tab: _vm.extraFieldTabs[_vm.tab - _vm.defaultTabs.length],
                      "name-settings": _vm.extraFieldNamesConfig,
                      readonly: "",
                    },
                  }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }